export var HiMedicalPlus = [
    { HiMedicalPlus: { '500': 195.47, '1200': 126.9 } },
    { HiMedicalPlus: { '500': 165.47, '1200': 108.63 } },
    { HiMedicalPlus: { '500': 135.87, '1200': 91.05 } },
    { HiMedicalPlus: { '500': 145.44, '1200': 97.88 } },
    { HiMedicalPlus: { '500': 156.04, '1200': 105.4 } },
    { HiMedicalPlus: { '500': 167.66, '1200': 113.65 } },
    { HiMedicalPlus: { '500': 180.04, '1200': 122.44 } },
    { HiMedicalPlus: { '500': 192.92, '1200': 131.54 } },
    { HiMedicalPlus: { '500': 205.16, '1200': 140.17 } },
    { HiMedicalPlus: { '500': 216.12, '1200': 147.88 } },
    { HiMedicalPlus: { '500': 225.29, '1200': 154.29 } },
    { HiMedicalPlus: { '500': 231.78, '1200': 158.8 } },
    { HiMedicalPlus: { '500': 235.48, '1200': 161.34 } },
    { HiMedicalPlus: { '500': 236.62, '1200': 162.06 } },
    { HiMedicalPlus: { '500': 236.66, '1200': 162.15 } },
    { HiMedicalPlus: { '500': 236.71, '1200': 162.27 } },
    { HiMedicalPlus: { '500': 236.78, '1200': 162.44 } },
    { HiMedicalPlus: { '500': 236.85, '1200': 162.65 } },
    { HiMedicalPlus: { '500': 236.94, '1200': 162.88 } },
    { HiMedicalPlus: { '500': 237.03, '1200': 163.13 } },
    { HiMedicalPlus: { '500': 237.13, '1200': 163.4 } },
    { HiMedicalPlus: { '500': 237.24, '1200': 163.69 } },
    { HiMedicalPlus: { '500': 237.35, '1200': 164.0 } },
    { HiMedicalPlus: { '500': 237.46, '1200': 164.34 } },
    { HiMedicalPlus: { '500': 237.58, '1200': 164.7 } },
    { HiMedicalPlus: { '500': 237.7, '1200': 165.08 } },
    { HiMedicalPlus: { '500': 241.4, '1200': 165.5 } },
    { HiMedicalPlus: { '500': 249.63, '1200': 167.86 } },
    { HiMedicalPlus: { '500': 259.52, '1200': 174.56 } },
    { HiMedicalPlus: { '500': 271.06, '1200': 182.44 } },
    { HiMedicalPlus: { '500': 284.13, '1200': 191.4 } },
    { HiMedicalPlus: { '500': 298.61, '1200': 201.37 } },
    { HiMedicalPlus: { '500': 314.12, '1200': 212.08 } },
    { HiMedicalPlus: { '500': 330.77, '1200': 223.62 } },
    { HiMedicalPlus: { '500': 348.44, '1200': 235.91 } },
    { HiMedicalPlus: { '500': 367.02, '1200': 248.86 } },
    { HiMedicalPlus: { '500': 386.99, '1200': 262.78 } },
    { HiMedicalPlus: { '500': 408.49, '1200': 277.71 } },
    { HiMedicalPlus: { '500': 431.26, '1200': 293.46 } },
    { HiMedicalPlus: { '500': 455.42, '1200': 310.11 } },
    { HiMedicalPlus: { '500': 480.97, '1200': 327.64 } },
    { HiMedicalPlus: { '500': 507.52, '1200': 345.86 } },
    { HiMedicalPlus: { '500': 534.83, '1200': 364.63 } },
    { HiMedicalPlus: { '500': 563.03, '1200': 384.05 } },
    { HiMedicalPlus: { '500': 592.12, '1200': 404.14 } },
    { HiMedicalPlus: { '500': 621.97, '1200': 424.81 } },
    { HiMedicalPlus: { '500': 653.09, '1200': 446.43 } },
    { HiMedicalPlus: { '500': 685.84, '1200': 469.22 } },
    { HiMedicalPlus: { '500': 719.97, '1200': 492.99 } },
    { HiMedicalPlus: { '500': 754.98, '1200': 517.36 } },
    { HiMedicalPlus: { '500': 790.86, '1200': 542.3 } },
    { HiMedicalPlus: { '500': 826.84, '1200': 567.26 } },
];
